var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"modalId":"modaLInfoBB","modalTitle":'Banco do Brasil',"load":false,"typeLg":"modal_wd"},on:{"closeModal":_vm.closeModal}},[_c('tabs',{attrs:{"item":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }